import { render, staticRenderFns } from "./summary-section.vue?vue&type=template&id=28c15d2c&scoped=true"
import script from "./summary-section.vue?vue&type=script&lang=js"
export * from "./summary-section.vue?vue&type=script&lang=js"
import style0 from "./summary-section.vue?vue&type=style&index=0&id=28c15d2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c15d2c",
  null
  
)

export default component.exports